import { useMutation, useQueryClient } from '@tanstack/react-query';
import { WalletConnector } from '@/modules/Wallet/interface/walet';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';
const connectInstitution = async (id: WalletConnector['id']) => {
  await api.post(apiConfig.routes.wallet.pluggy.items, {
    item_id: id
  });
};
export const useConnectInstitution = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: connectInstitution,
    onSettled: () => {
      [['wallet', 'summary'], ['wallet', 'institutions'], ['wallet', 'connectors'], ['consolidator', 'wallet', 'optimizer', 'status'], ['wallet', 'investments'], ['wallet', 'investments', 'categories'], ['wallet', 'investments', 'institutions'], ['wallet', 'optimizer', 'status']].forEach(key => {
        queryClient.invalidateQueries({
          queryKey: key
        });
      });
    }
  });
};